import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  @Input() modalCtrl: ModalController;

  constructor(public localData: LocaldataService, private router: Router) { }

  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }


  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    const tsBegin = Date.now();
    console.log(tsBegin);

    this.localData.remoteUpdateNotifications().then(()=>{

      const tsEnd = Date.now();
      const delay = ((tsEnd-tsBegin)<500) ? 500 - (tsEnd-tsBegin) : 0;

      console.log('delay', delay);

      setTimeout(() => {
        console.log('Async operation has ended');
        refresher.target.complete();
      }, delay);


    }).catch(() => {console.log('ERROR');})
  }

  ngOnInit() {
  }

}
